import React from "react";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_LINK } from "@/lib/site";

export default function WhatsAppFloat() {
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 z-50 group"
    >
      <span className="flex items-center gap-2 bg-[#0B302F] text-[#FDFBF7] pl-3 pr-4 py-3 rounded-full shadow-lg shadow-black/10 hover:shadow-black/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#2A5C5A]">
        <span className="bg-[#D5B876] text-[#0B302F] rounded-full p-1.5">
          <MessageCircle className="h-4 w-4" strokeWidth={1.8} />
        </span>
        <span className="hidden sm:inline text-xs tracking-[0.18em] uppercase">WhatsApp</span>
      </span>
    </a>
  );
}
